module.exports = __webpack_public_path__ + "media/wo_ye_hen_hao.6b9df6b9.mp3";